/**
 * Copyright © Veeam Software Group GmbH.
 */

import { VatAliasRepresentation } from '@veeam-vspc/models/web-controllers';

export type TaxTypes = VatAliasRepresentation;
export const TaxTypes = VatAliasRepresentation;
